<template lang="pug">
  .modal.modal--sm
    button.modal__close(
    @click="$emit('close')"
    )
      img(src="@/assets/images/icons/cross.svg")
    h2.modal__title Войти
    p.modal__text
    //| Добро пожаловать! Войдите в свой аккаунт чтобы оставлять заявки на Новогоднюю ёлку
    .modal__form
      form
        .form
          .form__elem
            .form-elem(
            :class="{ 'form-elem_error': userCredentialErrors.email }"
            )
              .form-elem__title Email
              .form-elem__main
                input(
                type="email"
                v-model="userCredentials.email"
                @keyup="resetError('email')"
                ).input.input_full
          .form__elem
            .form-elem(
            :class="{ 'form-elem_error': userCredentialErrors.password }"
            )
              .form-elem__title Пароль
              .form-elem__main
                input(
                type="password"
                v-model="userCredentials.password"
                @keyup="resetError('password')"
                ).input.input_full
          .form__elem
            .form-elem
              .form-elem__main
                button.button.button_paint-main.button_full(
                  :class="{ 'loaded-button': pending }"
                  @click.prevent="onAuth"
                )
                  .button__text Войти
              .form-elem__error(
              v-if="currentErrorMessage.length > 0"
              ) {{ currentErrorMessage }}
    .modal__links.modal-links.resend_link(
      v-if="showResendLink"
    )
      .modal-links__link
        a.link(
          @click.prevent="resendLink()"
        ) Выслать повторно
    .modal__links.modal-links
      .modal-links__link
        a.link(
        @click.prevent="$emit('changeModalMode', 'sign-up')"
        ) Зарегистрироваться
      .modal-links__link
        a.link(
        @click.prevent="$emit('changeModalMode', 'reset-password')"
        ) Забыли пароль?
</template>
<script>
import { mapActions } from "vuex";

export default {
  name: "sign-in",
  data() {
    return {
      pending: false,
      showResendLink: false,
      userCredentials: {
        email: "",
        password: "",
      },
      userCredentialErrors: {
        email: false,
        password: false,
      },
      errorMessages: {
        email: "Неверный формат email",
        password: "Пароль должен содержать минимум 8 символов",
      },
      currentErrorMessage: "",
    };
  },
  methods: {
    ...mapActions(["auth", "getUser", "getUserAwards", "resendAuthLink"]),
    resendLink() {
      this.resendAuthLink({
        email: this.userCredentials.email,
      }).then((res) => {
        this.pending = false;
        if (res.status === 200) {
          this.$emit("changeModalMode", "notification", {
            title: "Проверьте почту",
            text: `Мы выслали ссылку на ${this.userCredentials.email}`,
          });
        } else {
          this.currentErrorMessage = res.data.detail;
        }
      });
    },
    resetError(model) {
      this.userCredentialErrors[model] = false;
      this.currentErrorMessage = "";
      this.showResendLink = false;
    },
    onAuth() {
      this.pending = true;
      let errors = [];
      let emailReg = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      if (
        this.userCredentials.email.length === 0 ||
        !emailReg.test(this.userCredentials.email)
      ) {
        errors.push("email");
      }
      if (this.userCredentials.password.length < 8) {
        errors.push("password");
      }
      if (errors.length > 0) {
        this.pending = false;
        errors.map((el) => {
          this.userCredentialErrors[el] = true;
        });
        this.currentErrorMessage = this.errorMessages[errors[0]];
        return;
      }
      this.auth({
        userCredentials: {
          email: this.userCredentials.email,
          password: this.userCredentials.password,
        },
      }).then((res) => {
        if (res.status === 401) {
          // ошибка авторизации
          this.currentErrorMessage = res.data.detail;
          if (res.data.code === 2) {
            this.showResendLink = true;
          }
          this.userCredentialErrors.email = true;
          this.userCredentialErrors.password = true;
          this.pending = false;
          return;
        }
        this.getUser().then((res) => {
          if (res.role === 4) {
            this.getUserAwards().then((res) => {
              if (res.status === 401) {
                console.log(res.status);
              }
              this.pending = false;
              this.$emit("close");
              return;
            });
          }
          this.pending = false;
          this.$emit("close");
        });
      });
    },
  },
};
</script>
